import { SYSTEM_SHIPMENT_EVENT, SystemEventsLabels } from './system-shipment-event-types';

enum SHIPMENT_EVENT {
  NO_TRACKING = 'no_tracking_shipment_event',
  LOW_BATTERY_LEVEL = 'low_battery_level_shipment_event',
  HIGH_RISKSCORE = 'high_riskscore_alert_shipment_event',
  HIGH_TRAFFIC = 'high_traffic_shipment_event',
  PLANE_ALERT = 'plane_alert_shipment_event',
  PLANE_DELAYED = 'plane_delayed_shipment_event',
  SUBSCRIBED_TO_FLIGHT = 'subscribed_to_flight_alert_shipment_event',
  TEMPERATURE_EVENT = 'temperature_shipment_event',
  HUMIDITY_EVENT = 'humidity_shipment_event',
  SEPARATION_EVENT = 'separation_shipment_event',
  TRACK_EVENT = 'track_shipment_event',
  STOLEN = 'tractor_stolen_shipment_event',
  LOADLOCK = 'load_lock_shipment_event',
  HOT_ZONE_STOP = 'hot_zone_stop',
  RED_ZONE_STOP = 'red_zone_stop',
  SAFEZONE_STOP = 'safe_zone_stop',
  HOME_STOP = 'home_stop',
  UNPLANNED_STOP = 'unplanned_stop',
  PLANNED_STOP = 'planned_stop',
  REGULAR_RESTART = 'regular_restart',
  REDZONE_RESTART = 'red_zone_restart',
  HOT_ZONE_RESTART = 'hot_zone_restart',
  SAFE_ZONE_RESTART = 'safe_zone_restart',
  HOME_RESTART = 'home_restart',
  UNPLANNED_RESTART = 'unplanned_restart',
  PLANNED_RESTART = 'planned_restart',
  DANGER_ZONE_STOP = 'danger_zone_stop',
  DANGER_ZONE_RESTART = 'danger_zone_restart',
  FILTER_DANGER_ZONE_STOP = 'in_danger_zone_stop_shipment_event',
  DEVICE_INACTIVATE = 'device_inactive_pre_pickup_location_shipment_event',
  CLAIM_SUBMISSION = 'claim_submission_shipment_event',
  DRIVER_SOS = 'driver_sos_alert_shipment_event',
  ESTIMATED_MILESTONE = 'estimated_milestone_shipment_event',
  LIGHT_SHIPMENT_EVENT = 'light_shipment_event',
  STOP_EVENT = 'stop_event',
  AWB_BOOKED = 'awb_booked_shipment_event',
  AWB_CONSIGNEE_NOTIFIED = 'awb_consignee_notified_shipment_event',
  AWB_RECEIVED_FROM_FLIGHT = 'awb_received_from_flight_shipment_event',
  MILESTONE_SHIPMENT_AWAITING_PICKUP = 'shipment_awaiting_pickup_shipment_event',
  MILESTONE_SHIPMENT_CLOSED = 'shipment_closed_shipment_event',
  MILESTONE_SHIPMENT_IN_ROUTE_TO_PICKUP = 'shipment_in_route_to_pickup_shipment_event',
  CUSTOM_MILESTONE = 'custom_milestone_shipment_event',
  DEVICE_POWER_DOWN = 'device_power_down_shipment_event',
  CONTAINER_GATE_OUT_EMPTY = 'container_gate_out_empty_shipment_event',
  CONTAINER_GATE_IN_FULL = 'container_gate_in_full_shipment_event',
  CONTAINER_LOADED = 'container_loaded_shipment_event',
  CONTAINER_DEPARTURE = 'container_departure_shipment_event',
  CONTAINER_ARRIVAL = 'container_arrival_shipment_event',
  CONTAINER_DISCHARGED = 'container_discharged_shipment_event',
  CONTAINER_GATE_OUT_FULL = 'container_gate_out_full_shipment_event',
  CONTAINER_GATE_IN_EMPTY = 'container_gate_in_empty_shipment_event',

  INCIDENT_DOUBLE_LOADING = 'double_loading_manual_incident_shipment_event',
  INCIDENT_DAMAGED = 'damaged_manual_incident_shipment_event',
  INCIDENT_RESPONSE = 'incident_response_manual_incident_shipment_event',
  INCIDENT_PILFERAGE = 'pilferage_manual_incident_shipment_event',
  INCIDENT_RECOVERED = 'recovered_manual_incident_shipment_event',
  INCIDENT_SPOILED = 'spoiled_manual_incident_shipment_event',
  INCIDENT_THEFT = 'theft_manual_incident_shipment_event',
  INCIDENT_TRAFFIC_ACCIDENT = 'traffic_accident_manual_incident_shipment_event',

  MANUAL_CURRENT_STATUS_UPDATE = 'current_status_update_manual_shipment_event',
  MANUAL_ESCORT_ARRIVED_AT_ORIGIN = 'escort_arrived_at_origin_manual_shipment_event',
  MANUAL_ESCORT_ENDED = 'escort_ended_manual_shipment_event',
  MANUAL_PHONE_WATCH_STARTED = 'phone_watch_started_manual_shipment_event',
  MANUAL_PHONE_WATCH_ENDED = 'phone_watch_ended_manual_shipment_event',
  MANUAL_SHIPMENT_TELEMATICS_AUDIT = 'shipment_telematics_audit_manual_shipment_event',
  MANUAL_SHIPMENT_REASSIGNMENT = 'shipment_reassignment_manual_shipment_event',
  MANUAL_NO_CONTACT_MAINTAINED = 'no_contact_maintained_manual_shipment_event',
  MANUAL_SHIPMENT_INFO_VALIDATION = 'shipment_info_validation_manual_shipment_event',
  MANUAL_SHIPMENT_REPORTED_ISSUES = 'shipment_reported_issues_manual_shipment_event',

  REGULAR_STOP = 'regular_stop',
  PLANNED_ROUTE_DEVIATION_SHIPMENT_EVENT = 'planned_route_deviation_shipment_event',
  PICKUP_WITHOUT_TRACKING = 'pickup_without_tracking_shipment_event',
  INCOMPLETE_INFORMATION_SHIPMENT_EVENT = 'incomplete_information_shipment_event',
  TELEMATICS_UNAVAILABLE = 'telematics_unavailable_manual_shipment_event',
  PARTIAL_DELIVERY = 'partial_delivery_manual_shipment_event',
  MECHANICAL_FAILURE = 'mechanical_failure_manual_shipment_event',
  CONTAINER_WELLNESS_CHECK = 'container_wellness_check_manual_shipment_event',
  TRACTOR_SLOWDOWN = 'tractor_slowdown_shipment_event',

  DEPARTURE = 'departure_shipment_event',
  DELIVERY = 'finish_shipment_event',
  MANUAL_PLANNED_STOP = 'manual_submit_shipment_event',
  UPDATED_VESSEL_INFO = 'updated_vessel_info_shipment_event',
  INVALID_CONTAINER_TRACKING_AT_SEAPORT = 'invalid_container_tracking_at_seaport_shipment_event',
  CONTAINER_TRACKING_SUBSCRIBED = 'container_tracking_subscribed_shipment_event',
  NO_CONTAINER_SUBSCRIPTION_FOUND = 'no_container_subscription_found_shipment_event',
  LEAVE_DDI_RADIUS_SHIPMENT_EVENT = 'leave_ddi_radius_shipment_event',
  SHOCK_SHIPMENT_EVENT = 'shock_shipment_event',
  TILT_SHIPMENT_EVENT = 'tilt_shipment_event',
  DOOR_CLOSED_SHIPMENT_EVENT = 'door_closed_shipment_event',
  DOOR_OPEN_SHIPMENT_EVENT = 'door_open_shipment_event',
  DEVICE_REASSIGNMENT_SHIPMENT_EVENT = 'device_reassignment_shipment_event',
  INCOMPLETE_PRE_CHECK = 'incomplete_pre_check',
  DELAYED_DEPARTURE_AFTER_PICKUP_SHIPMENT_EVENT = 'delayed_departure_after_pickup_shipment_event',
  PANIC_ALERT_SHIPMENT_EVENT = 'panic_alert_shipment_event',
  NON_REDZONE_STOP = 'non_redzone_stop',
  MOVING_AWAY_FROM_DELIVERY_SHIPMENT_EVENT = 'moving_away_from_delivery_shipment_event',
  TTS_THRESHOLD_EXCEEDED_SHIPMENT_EVENT = 'tts_threshold_exceeded_shipment_event',
  TTS_VALIDATED_DURATION_EXCEEDED_SHIPMENT_EVENT = 'tts_validated_duration_exceeded_shipment_event',
  LEAVING_LOCKDOWN_LOCATION_SHIPMENT_EVENT = 'leaving_lockdown_location_shipment_event',
  DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'detention_time_exceeded_shipment_event',
  MISSING_POD = 'missing_pod',
  MISSING_DDI = 'missing_ddi',
  EARLY_FINAL_DELIVERY_DEPARTURE_SHIPMENT_EVENT = 'early_final_delivery_departure_shipment_event',
  CANCELLED_FLIGHT_ALERT_SHIPMENT_EVENT = 'cancelled_flight_alert_shipment_event',
  MISSED_FLIGHT_ALERT_SHIPMENT_EVENT = 'missed_flight_alert_shipment_event',
  WRONG_FLIGHT_NUMBER_ALERT_SHIPMENT_EVENT = 'wrong_flight_number_alert_shipment_event',
  AIRPORT_WAIT_TIME_EXCEEDED_SHIPMENT_EVENT = 'airport_wait_time_exceeded_shipment_event',
  NO_DEVICE_TRACKING_AT_FLIGHT_DEPARTURE_SHIPMENT_EVENT = 'no_device_tracking_at_flight_departure_shipment_event',
  DEVICE_OFF_SITE_AT_FLIGHT_DEPARTURE_SHIPMENT_EVENT = 'device_off_site_at_flight_departure_shipment_event',
  MISSED_SHIP_ALERT_SHIPMENT_EVENT = 'missed_ship_alert_shipment_event',
  NO_VESSEL_INFO_SHIPMENT_EVENT = 'no_vessel_info_shipment_event',
  NO_ROUTE_BETWEEN_PORTS_SHIPMENT_EVENT = 'no_route_between_ports_shipment_event',
  VESSEL_BERTHED = 'vessel_berthed_shipment_event',
  MISMATCHED_SEAPORT_INFO = 'mismatched_seaport_info_shipment_event',
  LATE_DEPARTURE_PICKUP_SHIPMENT_EVENT = 'late_departure_pickup_shipment_event',
  INVALID_VESSEL_INFO = 'invalid_vessel_info_shipment_event',
  DELAYED_VESSEL_ARRIVAL = 'delayed_vessel_arrival_shipment_event',
  DISCHARGED_AT_TRANSSHIPMENT_PORT_SHIPMENT_EVENT = 'container_discharged_at_transshipment_port_shipment_event',
  DEPARTURE_FROM_TRANSSHIPMENT_PORT_SHIPMENT_EVENT = 'container_departure_from_transshipment_port_shipment_event',
  OCEAN_MODE_WARNING_AT_ORIGIN = 'ocean_mode_warning_at_origin_shipment_event',
  OCEAN_MODE_WARNING_AT_DESTINATION = 'ocean_mode_warning_at_destination_shipment_event',
  CONTAINER_ARRIVAL_AT_TRANSSIPMENT_PORT_SHIPMENT_EVENT = 'container_arrival_at_transshipment_port_shipment_event',
  CONTAINER_LOADED_AT_TRANSSIPMENT_PORT_SHIPMENT_EVENT = 'container_loaded_at_transshipment_port_shipment_event',
  RISK_ZONE_NO_TRACKING = 'risk_zone_no_tracking_shipment_event',
  NON_RISK_ZONE_NO_TRACKING = 'non_risk_zone_no_tracking_shipment_event',
  INVALID_FLIGHT_TRACKING = 'invalid_flight_tracking_shipment_event',
  REGIONAL_WORKFLOW_IN_USE_SHIPMENT_EVENT = 'regional_workflow_in_use_shipment_event',
  SHIPMENT_WORKFLOW_IN_USE_SHIPMENT_EVENT = 'shipment_workflow_in_use_shipment_event',
  IN_HOTZONE_STOP_SHIPMENT_EVENT = 'in_hot_zone_stop_shipment_event',
  UNPLANNED_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'unplanned_detention_time_exceeded_shipment_event',
  IN_SAFE_ZONE_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'in_safe_zone_detention_time_exceeded_shipment_event',
  DOOR_STATE_CHANGE_SHIPMENT_EVENT = 'door_state_change_shipment_event',
  IN_RED_ZONE_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'in_red_zone_detention_time_exceeded_shipment_event',
  IN_RED_ZONE_STOP_SHIPMENT_EVENT = 'in_red_zone_stop_shipment_event',
  RED_ZONE_CROSSED_SHIPMENT_EVENT = 'red_zone_crossed_shipment_event',
  IN_HOT_ZONE_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'in_hot_zone_detention_time_exceeded_shipment_event',
  NEAR_PLANNED_STOP_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'near_planned_stop_detention_time_exceeded_shipment_event',
  NEAR_DELIVERY_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'near_delivery_detention_time_exceeded_shipment_event',
  NEAR_HOME_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'near_home_detention_time_exceeded_shipment_event',
  NEAR_PICKUP_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT = 'near_pickup_detention_time_exceeded_shipment_event',
  READY_SHIPMENT_EVENT = 'ready_shipment_event',
  DRIVER_CHECKLIST_SHIPMENT_EVENT = 'driver_checklist_shipment_event',
  DELIVER_SHIPMENT_EVENT = 'deliver_shipment_event',
  ARRIVAL_SHIPMENT_EVENT = 'arrival_shipment_event',
  ETA_EXCEEDING_DELIVERY_SHIPMENT_EVENT = 'eta_exceeding_delivery_shipment_event',
  PLANE_DELAYED_ARRIVAL_SHIPMENT_EVENT = 'plane_delayed_arrival_shipment_event',
  CHECKOUT_SHIPMENT_EVENT = 'checkout_shipment_event',
  DOOR_TEMPER_SHIPMENT_EVENT = 'door_tamper_shipment_event',
  EARLY_ETA_DELIVERY_SHIPMENT_EVENT = 'early_eta_delivery_shipment_event',
  SEAL_OPEN = 'seal_open_shipment_event',
  SEAL_CLOSED = 'seal_closed_shipment_event',
  SHIPMENT_MOVED_TO_AT_PICKUP = 'shipment_moved_to_at_pickup_shipment_event',
  SHIP_DEPARTURE = 'ship_departure_shipment_event',
  IGNITION_OFF = 'ignition_off_shipment_event',
  IGNITION_ON = 'ignition_on_shipment_event',
  MILESTONE_DELIVERED = 'milestone_delivered_shipment_event',
  MILESTONE_PICKED_UP = 'milestone_picked_up_shipment_event',
  PLANE_DEPARTURE = 'plane_departure_shipment_event',
  INCOMPLETE_PICKUP_SUBMISSION = 'incomplete_pickup_submission_shipment_event',
  INCOMPLETE_PRE_CHECK_SHIPMENT_EVENT = 'incomplete_pre_check_shipment_event',
  ARRIVAL_AT_SEAPORT_LOCATION = 'arrival_at_seaport_location',
  LEAVE_LOCATION = 'leave_location_shipment_event',
  ENTER_DELIVERY_LOCATION = 'enter_delivery_location_shipment_event',
  ARRIVAL_AT_AIRPORT_LOCATION = 'arrival_at_airport_location',
  SEAL_LOW_BATTERY_LEVEL = 'seal_low_battery_level_shipment_event',
  UNAPPROVED_DRIVER = 'unapproved_driver_shipment_event',
  UNAPPROVED_CARRIER = 'unapproved_carrier_shipment_event',
  COLDCHAIN_TEMPERATURE_ALERT = 'cold_chain_temperature_shipment_event',
  DISTANCE_TO_DESTINATION_ALERT = 'distance_to_destination_alert_shipment_event',
  DEMURRAGE_WARNING_AT_DESTINATION_PORT = 'demurrage_warning_at_destination_port_shipment_event',
  TAG_SEPARATED = 'tag_separated_shipment_event',
  TAG_REUNITED = 'tag_reunited_shipment_event',
  OPEN_MIC_ZONE_ENTER = 'open_mic_zone_enter_shipment_event',
  OPEN_MIC_ZONE_EXIT = 'open_mic_zone_exit_shipment_event',
  LIGHT_AND_STOP_COMPOUND = 'light_and_stop_compound_shipment_event',
  RED_ZONE_TRACTOR_SLOWDOWN = 'in_red_zone_tractor_slowdown_shipment_event',
  SAFE_ZONE_TRACTOR_SLOWDOWN = 'in_safe_zone_tractor_slowdown_shipment_event',
  DANGER_ZONE_TRACTOR_SLOWDOWN = 'in_danger_zone_tractor_slowdown_shipment_event',
  HOT_ZONE_TRACTOR_SLOWDOWN = 'in_hot_zone_tractor_slowdown_shipment_event',
  OPEN_MIC_ZONE_TRACTOR_SLOWDOWN = 'in_open_mic_zone_tractor_slowdown_shipment_event',
  DECIDE_RISK_GPT_SHIPMENT_EVENT = 'decide_risk_gpt_shipment_event',
  UPDATED_FLIGHT_INFO = 'updated_flight_info_shipment_event',
  AWB_MANIFEST_ON_FLIGHT = 'awb_manifest_on_flight_shipment_event',
  CARRIER_RISKSCORE_SHIPMENT_EVENT = 'carrier_riskscore_shipment_event',
  AWB_SPLIT_SHIPMENT = 'awb_split_shipment_event',
  CONVOY_SEPARATION = 'convoy_separation_shipment_event',
  SHIPMENT_STAGING = 'staging_shipment_event',
  REMOVE_FROM_CONVOY = 'remove_from_convoy_shipment_event',
  DOUBLE_BROKERED_SHIPMENT_EVENT = 'shipment_double_brokered_shipment_event',
  DRIVER_RISKSCORE_SHIPMENT_EVENT = 'driver_riskscore_shipment_event',
  FIRST_TIME_DRIVER_SHIPMENT_EVENT = 'first_time_driver_shipment_event',
  FIRST_TIME_CARRIER_SHIPMENT_EVENT = 'first_time_carrier_shipment_event',
  RED_FLAG_PHOTO_ALERT = 'red_flag_photo_alert_shipment_event',
  PICKUP_APPROVAL_REQUESTED_SHIPMENT_EVENT = 'pickup_approval_requested_shipment_event',
  DRIVER_LICENSE_VERIFICATION_FAILED_SHIPMENT_EVENT = 'driver_license_verification_failed_shipment_event',
  OUT_OF_HOURS_SEAPORT_DEPARTURE = 'out_of_hours_seaport_departure_shipment_event',
  TELEMATICS_JAMMING = 'telematics_jamming_shipment_event',
  ITEM_QUALITY_TEMPERATURE = 'item_quality_temperature_shipment_event'
}

/**
 * Events which cannot be generated in system anymore but exists in historical data
 */
type LegacyShipmentEvent =
  | SHIPMENT_EVENT.NO_ROUTE_BETWEEN_PORTS_SHIPMENT_EVENT;
type LegacyShipmentEventLabels = { [key in LegacyShipmentEvent]: string };

type ShipmentEventsLabels = {
  [key in SHIPMENT_EVENT]: string;
};

type CombinedShipmentEventsLabels = ShipmentEventsLabels & SystemEventsLabels & LegacyShipmentEventLabels;

export const SHIPMENT_EVENTS_LABELS: (CombinedShipmentEventsLabels) = new Proxy({
  [SHIPMENT_EVENT.NO_TRACKING]: 'event_no_tracking_shipment_event',
  [SHIPMENT_EVENT.LOW_BATTERY_LEVEL]: 'event_low_battery_level_shipment_event',
  [SHIPMENT_EVENT.HIGH_RISKSCORE]: 'event_high_riskscore_alert_shipment_event',
  [SHIPMENT_EVENT.PICKUP_WITHOUT_TRACKING]: 'event_pickup_without_tracking_shipment_event',
  [SHIPMENT_EVENT.HIGH_TRAFFIC]: 'event_high_traffic_shipment_event',
  [SHIPMENT_EVENT.PLANE_ALERT]: SHIPMENT_EVENT.PLANE_ALERT,
  [SHIPMENT_EVENT.PLANE_DELAYED]: 'event_plane_delayed_shipment_event',
  [SHIPMENT_EVENT.SUBSCRIBED_TO_FLIGHT]: 'event_subscribed_to_flight_alert_shipment_event',
  [SHIPMENT_EVENT.TEMPERATURE_EVENT]: 'event_temperature_shipment_event',
  [SHIPMENT_EVENT.HUMIDITY_EVENT]: 'event_humidity_shipment_event',
  [SHIPMENT_EVENT.SEPARATION_EVENT]: 'event_separation_shipment_event',
  [SHIPMENT_EVENT.TRACK_EVENT]: 'event_track_shipment_event',
  [SHIPMENT_EVENT.STOLEN]: 'event_tractor_stolen_shipment_event',
  [SHIPMENT_EVENT.LOADLOCK]: 'event_load_lock_shipment_event',
  [SHIPMENT_EVENT.REGULAR_STOP]: SHIPMENT_EVENT.REGULAR_STOP,
  [SHIPMENT_EVENT.HOT_ZONE_STOP]: SHIPMENT_EVENT.HOT_ZONE_STOP,
  [SHIPMENT_EVENT.RED_ZONE_STOP]: SHIPMENT_EVENT.RED_ZONE_STOP,
  [SHIPMENT_EVENT.SAFEZONE_STOP]: SHIPMENT_EVENT.SAFEZONE_STOP,
  [SHIPMENT_EVENT.HOME_STOP]: 'event_home_stop',
  [SHIPMENT_EVENT.UNPLANNED_STOP]: 'event_unplannedStop',
  [SHIPMENT_EVENT.PLANNED_STOP]: 'event_planned_stop',
  [SHIPMENT_EVENT.REGULAR_RESTART]: 'event_regular_restart',
  [SHIPMENT_EVENT.REDZONE_RESTART]: 'event_red_zone_restart',
  [SHIPMENT_EVENT.HOT_ZONE_RESTART]: 'event_hot_zone_restart',
  [SHIPMENT_EVENT.SAFE_ZONE_RESTART]: 'event_safe_zone_restart',
  [SHIPMENT_EVENT.HOME_RESTART]: 'event_home_restart',
  [SHIPMENT_EVENT.UNPLANNED_RESTART]: 'event_unplanned_restart',
  [SHIPMENT_EVENT.PLANNED_RESTART]: 'event_planned_restart',
  [SHIPMENT_EVENT.DEVICE_INACTIVATE]: 'event_device_inactive_pre_pickup_location_shipment_event',
  [SHIPMENT_EVENT.CLAIM_SUBMISSION]: 'event_claim_submission_shipment_event',
  [SHIPMENT_EVENT.DRIVER_SOS]: 'event_driver_sos_alert_shipment_event',
  [SHIPMENT_EVENT.ESTIMATED_MILESTONE]: 'event_estimated_milestone_shipment_event',
  [SHIPMENT_EVENT.LIGHT_SHIPMENT_EVENT]: 'event_light_shipment_event',
  [SHIPMENT_EVENT.STOP_EVENT]: 'event_stop_event',
  [SHIPMENT_EVENT.AWB_BOOKED]: 'event_awb_booked_shipment_event',
  [SHIPMENT_EVENT.AWB_CONSIGNEE_NOTIFIED]: 'event_awb_consignee_notified_shipment_event',
  [SHIPMENT_EVENT.AWB_RECEIVED_FROM_FLIGHT]: 'event_awb_received_from_flight_shipment_event',
  [SHIPMENT_EVENT.MILESTONE_SHIPMENT_AWAITING_PICKUP]: 'event_shipment_awaiting_pickup_shipment_event',
  [SHIPMENT_EVENT.MILESTONE_SHIPMENT_CLOSED]: 'event_shipment_closed_shipment_event',
  [SHIPMENT_EVENT.MILESTONE_SHIPMENT_IN_ROUTE_TO_PICKUP]: 'event_shipment_in_route_to_pickup_shipment_event',
  [SHIPMENT_EVENT.CUSTOM_MILESTONE]: 'event_custom_milestone_shipment_event',
  [SHIPMENT_EVENT.DEVICE_POWER_DOWN]: 'event_device_power_down_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_GATE_OUT_EMPTY]: 'event_container_gate_out_empty_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_GATE_IN_FULL]: 'event_container_gate_in_full_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_LOADED]: 'event_container_loaded_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_DEPARTURE]: 'event_container_departure_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_ARRIVAL]: 'event_container_arrival_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_DISCHARGED]: 'event_container_discharged_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_GATE_OUT_FULL]: 'event_container_gate_out_full_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_GATE_IN_EMPTY]: 'event_container_gate_in_empty_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_DOUBLE_LOADING]: 'event_double_loading_manual_incident_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_DAMAGED]: 'event_damaged_manual_incident_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_RESPONSE]: 'event_incident_response_manual_incident_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_PILFERAGE]: 'event_pilferage_manual_incident_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_RECOVERED]: 'event_recovered_manual_incident_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_SPOILED]: 'event_spoiled_manual_incident_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_THEFT]: 'event_theft_manual_incident_shipment_event',
  [SHIPMENT_EVENT.INCIDENT_TRAFFIC_ACCIDENT]: 'event_traffic_accident_manual_incident_shipment_event',
  [SHIPMENT_EVENT.DEPARTURE]: 'event_departure_shipment_event',
  [SHIPMENT_EVENT.DELIVERY]: 'event_finish_shipment_event',
  [SHIPMENT_EVENT.MANUAL_PLANNED_STOP]: SHIPMENT_EVENT.MANUAL_PLANNED_STOP,
  [SHIPMENT_EVENT.UPDATED_VESSEL_INFO]: 'event_updated_vessel_info_shipment_event',
  [SHIPMENT_EVENT.INVALID_CONTAINER_TRACKING_AT_SEAPORT]: 'event_invalid_container_tracking_at_seaport_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_TRACKING_SUBSCRIBED]: 'event_container_tracking_subscribed_shipment_event',
  [SHIPMENT_EVENT.NO_CONTAINER_SUBSCRIPTION_FOUND]: 'event_no_container_subscription_found_shipment_event',
  [SHIPMENT_EVENT.LEAVE_DDI_RADIUS_SHIPMENT_EVENT]: 'event_leave_ddi_radius_shipment_event',
  [SHIPMENT_EVENT.SHOCK_SHIPMENT_EVENT]: 'event_shock_shipment_event',
  [SHIPMENT_EVENT.TILT_SHIPMENT_EVENT]: 'event_tilt_shipment_event',
  [SHIPMENT_EVENT.DOOR_CLOSED_SHIPMENT_EVENT]: 'event_door_closed_shipment_event',
  [SHIPMENT_EVENT.DOOR_OPEN_SHIPMENT_EVENT]: 'event_door_open_shipment_event',
  [SHIPMENT_EVENT.DEVICE_REASSIGNMENT_SHIPMENT_EVENT]: 'event_device_reassignment_shipment_event',
  [SHIPMENT_EVENT.INCOMPLETE_PRE_CHECK]: 'event_incomplete_pre_check_shipment_event',
  [SHIPMENT_EVENT.DELAYED_DEPARTURE_AFTER_PICKUP_SHIPMENT_EVENT]: 'event_delayed_departure_after_pickup_shipment_event',
  [SHIPMENT_EVENT.LATE_DEPARTURE_PICKUP_SHIPMENT_EVENT]: 'late_departure_pickup_shipment_event',
  [SHIPMENT_EVENT.PANIC_ALERT_SHIPMENT_EVENT]: 'event_panic_alert_shipment_event',
  [SHIPMENT_EVENT.NON_REDZONE_STOP]: 'event_non_redzone_stop',
  [SHIPMENT_EVENT.PLANNED_ROUTE_DEVIATION_SHIPMENT_EVENT]: 'event_planned_route_deviation_shipment_event',
  [SHIPMENT_EVENT.MOVING_AWAY_FROM_DELIVERY_SHIPMENT_EVENT]: 'event_moving_away_from_delivery_shipment_event',
  [SHIPMENT_EVENT.TTS_THRESHOLD_EXCEEDED_SHIPMENT_EVENT]: 'event_tts_threshold_exceeded_shipment_event',
  [SHIPMENT_EVENT.TTS_VALIDATED_DURATION_EXCEEDED_SHIPMENT_EVENT]: 'event_tts_validated_duration_exceeded_shipment_event',
  [SHIPMENT_EVENT.LEAVING_LOCKDOWN_LOCATION_SHIPMENT_EVENT]: 'event_leaving_lockdown_location_shipment_event',
  [SHIPMENT_EVENT.DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: 'event_detention_time_exceeded_shipment_event',
  [SHIPMENT_EVENT.MISSING_POD]: 'event_missing_pod',
  [SHIPMENT_EVENT.MISSING_DDI]: 'event_missing_ddi',
  [SHIPMENT_EVENT.EARLY_FINAL_DELIVERY_DEPARTURE_SHIPMENT_EVENT]: 'event_early_final_delivery_departure_shipment_event',
  [SHIPMENT_EVENT.INCOMPLETE_INFORMATION_SHIPMENT_EVENT]: 'event_incomplete_information_shipment_event',
  [SHIPMENT_EVENT.CANCELLED_FLIGHT_ALERT_SHIPMENT_EVENT]: 'event_cancelled_flight_alert_shipment_event',
  [SHIPMENT_EVENT.MISSED_FLIGHT_ALERT_SHIPMENT_EVENT]: 'event_missed_flight_alert_shipment_event',
  [SHIPMENT_EVENT.WRONG_FLIGHT_NUMBER_ALERT_SHIPMENT_EVENT]: 'event_wrong_flight_number_alert_shipment_event',
  [SHIPMENT_EVENT.AIRPORT_WAIT_TIME_EXCEEDED_SHIPMENT_EVENT]: 'event_airport_wait_time_exceeded_shipment_event',
  [SHIPMENT_EVENT.NO_DEVICE_TRACKING_AT_FLIGHT_DEPARTURE_SHIPMENT_EVENT]: 'event_no_device_tracking_at_flight_departure_shipment_event',
  [SHIPMENT_EVENT.DEVICE_OFF_SITE_AT_FLIGHT_DEPARTURE_SHIPMENT_EVENT]: 'event_device_off_site_at_flight_departure_shipment_event',
  [SHIPMENT_EVENT.MISSED_SHIP_ALERT_SHIPMENT_EVENT]: 'event_missed_ship_alert_shipment_event',
  [SHIPMENT_EVENT.NO_VESSEL_INFO_SHIPMENT_EVENT]: 'event_no_vessel_info_shipment_event',
  [SHIPMENT_EVENT.DELAYED_VESSEL_ARRIVAL]: 'event_delayed_vessel_arrival_shipment_event',
  [SHIPMENT_EVENT.NO_ROUTE_BETWEEN_PORTS_SHIPMENT_EVENT]: 'event_no_route_between_ports_shipment_event',
  [SHIPMENT_EVENT.DISCHARGED_AT_TRANSSHIPMENT_PORT_SHIPMENT_EVENT]: 'event_container_discharged_at_transshipment_port_shipment_event',
  [SHIPMENT_EVENT.DEPARTURE_FROM_TRANSSHIPMENT_PORT_SHIPMENT_EVENT]: 'event_container_departure_from_transshipment_port_shipment_event',
  [SHIPMENT_EVENT.OCEAN_MODE_WARNING_AT_ORIGIN]: 'event_ocean_mode_warning_at_origin_shipment_event',
  [SHIPMENT_EVENT.OCEAN_MODE_WARNING_AT_DESTINATION]: 'event_ocean_mode_warning_at_destination_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_ARRIVAL_AT_TRANSSIPMENT_PORT_SHIPMENT_EVENT]: 'event_container_arrival_at_transshipment_port_shipment_event',
  [SHIPMENT_EVENT.CONTAINER_LOADED_AT_TRANSSIPMENT_PORT_SHIPMENT_EVENT]: 'event_container_loaded_at_transshipment_port_shipment_event',
  [SHIPMENT_EVENT.MANUAL_NO_CONTACT_MAINTAINED]: SHIPMENT_EVENT.MANUAL_NO_CONTACT_MAINTAINED,
  [SHIPMENT_EVENT.INVALID_FLIGHT_TRACKING]: 'event_invalid_flight_tracking_shipment_event',
  [SHIPMENT_EVENT.TELEMATICS_UNAVAILABLE]: 'event_telematics_unavailable_manual_shipment_event',
  [SHIPMENT_EVENT.PARTIAL_DELIVERY]: 'event_partial_delivery_manual_shipment_event',
  [SHIPMENT_EVENT.MECHANICAL_FAILURE]: 'event_mechanical_failure_manual_shipment_event',
  [SHIPMENT_EVENT.IN_HOTZONE_STOP_SHIPMENT_EVENT]: 'event_in_hot_zone_stop_shipment_event',
  [SHIPMENT_EVENT.UNPLANNED_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: 'event_unplanned_detention_time_exceeded_shipment_event',
  [SHIPMENT_EVENT.IN_SAFE_ZONE_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: 'event_in_safe_zone_detention_time_exceeded_shipment_event',
  [SHIPMENT_EVENT.RISK_ZONE_NO_TRACKING]: 'event_risk_zone_no_tracking_shipment_event',
  [SHIPMENT_EVENT.NON_RISK_ZONE_NO_TRACKING]: 'event_non_risk_zone_no_tracking_shipment_event',
  [SHIPMENT_EVENT.DOOR_STATE_CHANGE_SHIPMENT_EVENT]: 'door_state_change_shipment_event',
  [SHIPMENT_EVENT.IN_RED_ZONE_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: 'in_red_zone_detention_time_exceeded_shipment_event',
  [SHIPMENT_EVENT.IN_RED_ZONE_STOP_SHIPMENT_EVENT]: 'in_red_zone_stop_shipment_event',
  [SHIPMENT_EVENT.IN_HOT_ZONE_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: SHIPMENT_EVENT.IN_HOT_ZONE_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.NEAR_PLANNED_STOP_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: SHIPMENT_EVENT.NEAR_PLANNED_STOP_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.NEAR_DELIVERY_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: SHIPMENT_EVENT.NEAR_DELIVERY_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.RED_ZONE_CROSSED_SHIPMENT_EVENT]: 'event_red_zone_crossed_shipment_event',
  [SHIPMENT_EVENT.MANUAL_CURRENT_STATUS_UPDATE]: SHIPMENT_EVENT.MANUAL_CURRENT_STATUS_UPDATE,
  [SHIPMENT_EVENT.MANUAL_ESCORT_ARRIVED_AT_ORIGIN]: SHIPMENT_EVENT.MANUAL_ESCORT_ARRIVED_AT_ORIGIN,
  [SHIPMENT_EVENT.NEAR_HOME_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: SHIPMENT_EVENT.NEAR_HOME_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.MANUAL_ESCORT_ENDED]: SHIPMENT_EVENT.MANUAL_ESCORT_ENDED,
  [SHIPMENT_EVENT.MANUAL_PHONE_WATCH_STARTED]: SHIPMENT_EVENT.MANUAL_PHONE_WATCH_STARTED,
  [SHIPMENT_EVENT.MANUAL_PHONE_WATCH_ENDED]: SHIPMENT_EVENT.MANUAL_PHONE_WATCH_ENDED,
  [SHIPMENT_EVENT.MANUAL_SHIPMENT_TELEMATICS_AUDIT]: SHIPMENT_EVENT.MANUAL_SHIPMENT_TELEMATICS_AUDIT,
  [SHIPMENT_EVENT.MANUAL_SHIPMENT_REASSIGNMENT]: SHIPMENT_EVENT.MANUAL_SHIPMENT_REASSIGNMENT,
  [SHIPMENT_EVENT.MANUAL_SHIPMENT_INFO_VALIDATION]: 'event_shipmentInfoValidation',
  [SHIPMENT_EVENT.MANUAL_SHIPMENT_REPORTED_ISSUES]: 'event_shipmentReportedIssues',
  [SHIPMENT_EVENT.VESSEL_BERTHED]: SHIPMENT_EVENT.VESSEL_BERTHED,
  [SHIPMENT_EVENT.MISMATCHED_SEAPORT_INFO]: SHIPMENT_EVENT.MISMATCHED_SEAPORT_INFO,
  [SHIPMENT_EVENT.INVALID_VESSEL_INFO]: SHIPMENT_EVENT.INVALID_VESSEL_INFO,
  [SHIPMENT_EVENT.REGIONAL_WORKFLOW_IN_USE_SHIPMENT_EVENT]: SHIPMENT_EVENT.REGIONAL_WORKFLOW_IN_USE_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.SHIPMENT_WORKFLOW_IN_USE_SHIPMENT_EVENT]: SHIPMENT_EVENT.SHIPMENT_WORKFLOW_IN_USE_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.NEAR_PICKUP_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT]: SHIPMENT_EVENT.NEAR_PICKUP_DETENTION_TIME_EXCEEDED_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.READY_SHIPMENT_EVENT]: SHIPMENT_EVENT.READY_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.DELIVER_SHIPMENT_EVENT]: SHIPMENT_EVENT.DELIVER_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.ARRIVAL_SHIPMENT_EVENT]: SHIPMENT_EVENT.ARRIVAL_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.ETA_EXCEEDING_DELIVERY_SHIPMENT_EVENT]: SHIPMENT_EVENT.ETA_EXCEEDING_DELIVERY_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.PLANE_DELAYED_ARRIVAL_SHIPMENT_EVENT]: SHIPMENT_EVENT.PLANE_DELAYED_ARRIVAL_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.CHECKOUT_SHIPMENT_EVENT]: SHIPMENT_EVENT.CHECKOUT_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.DOOR_TEMPER_SHIPMENT_EVENT]: SHIPMENT_EVENT.DOOR_TEMPER_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.EARLY_ETA_DELIVERY_SHIPMENT_EVENT]: SHIPMENT_EVENT.EARLY_ETA_DELIVERY_SHIPMENT_EVENT,
  [SHIPMENT_EVENT.SEAL_OPEN]: SHIPMENT_EVENT.SEAL_OPEN,
  [SHIPMENT_EVENT.SEAL_CLOSED]: SHIPMENT_EVENT.SEAL_CLOSED,
  [SHIPMENT_EVENT.SHIPMENT_MOVED_TO_AT_PICKUP]: 'event_shipment_moved_to_at_pickup_shipment_event',
  [SHIPMENT_EVENT.SHIP_DEPARTURE]: 'event_ship_departure_shipment_event',
  [SHIPMENT_EVENT.IGNITION_OFF]: 'event_ignition_off_shipment_event',
  [SHIPMENT_EVENT.IGNITION_ON]: 'event_ignition_on_shipment_event',
  [SHIPMENT_EVENT.MILESTONE_DELIVERED]: SHIPMENT_EVENT.MILESTONE_DELIVERED,
  [SHIPMENT_EVENT.MILESTONE_PICKED_UP]: SHIPMENT_EVENT.MILESTONE_PICKED_UP,
  [SHIPMENT_EVENT.PLANE_DEPARTURE]: 'event_plane_departure_shipment_event',
  [SHIPMENT_EVENT.INCOMPLETE_PICKUP_SUBMISSION]: 'event_incomplete_pickup_submission_shipment_event',
  [SHIPMENT_EVENT.INCOMPLETE_PRE_CHECK_SHIPMENT_EVENT]: 'event_incomplete_pre_check_shipment_event',
  [SHIPMENT_EVENT.ARRIVAL_AT_SEAPORT_LOCATION]: 'event_arrival_at_seaport_location',
  [SHIPMENT_EVENT.LEAVE_LOCATION]: 'event_leave_location_shipment_event',
  [SHIPMENT_EVENT.ENTER_DELIVERY_LOCATION]: 'event_enter_delivery_location_shipment_event',
  [SHIPMENT_EVENT.ARRIVAL_AT_AIRPORT_LOCATION]: 'event_arrival_at_airport_location',
  [SHIPMENT_EVENT.SEAL_LOW_BATTERY_LEVEL]: 'event_seal_low_battery_level_shipment_event',
  [SHIPMENT_EVENT.UNAPPROVED_DRIVER]: 'event_unapproved_driver_shipment_event',
  [SHIPMENT_EVENT.UNAPPROVED_CARRIER]: 'event_unapproved_carrier_shipment_event',
  [SHIPMENT_EVENT.COLDCHAIN_TEMPERATURE_ALERT]: 'event_coldChainTemperatureAlert',
  [SHIPMENT_EVENT.DISTANCE_TO_DESTINATION_ALERT]: 'event_distanceToDestinationAlert',
  [SHIPMENT_EVENT.DANGER_ZONE_STOP]: 'event_dangerZoneStop',
  [SHIPMENT_EVENT.DANGER_ZONE_RESTART]: 'event_dangerZoneRestart',
  [SHIPMENT_EVENT.DEMURRAGE_WARNING_AT_DESTINATION_PORT]: 'event_demurrageWarningAtDestinationPort',
  [SHIPMENT_EVENT.TAG_SEPARATED]: 'event_tagSeparated',
  [SHIPMENT_EVENT.TAG_REUNITED]: 'event_tagReunited',
  [SHIPMENT_EVENT.FILTER_DANGER_ZONE_STOP]: 'event_dangerZoneStop',
  [SHIPMENT_EVENT.OPEN_MIC_ZONE_ENTER]: 'event_openMicZoneEnter',
  [SHIPMENT_EVENT.OPEN_MIC_ZONE_EXIT]: 'event_openMicZoneExit',
  [SHIPMENT_EVENT.CONTAINER_WELLNESS_CHECK]: 'event_containerWellnessCheck',
  [SHIPMENT_EVENT.LIGHT_AND_STOP_COMPOUND]: 'event_lightStopCompound',
  [SHIPMENT_EVENT.TRACTOR_SLOWDOWN]: 'event_tractorSlowdown',
  [SHIPMENT_EVENT.RED_ZONE_TRACTOR_SLOWDOWN]: 'event_redzoneTractorSlowdown',
  [SHIPMENT_EVENT.SAFE_ZONE_TRACTOR_SLOWDOWN]: 'event_safezoneTractorSlowdown',
  [SHIPMENT_EVENT.DANGER_ZONE_TRACTOR_SLOWDOWN]: 'event_dangerZoneTractorSlowdown',
  [SHIPMENT_EVENT.HOT_ZONE_TRACTOR_SLOWDOWN]: 'event_hotZoneTractorSlowdown',
  [SHIPMENT_EVENT.OPEN_MIC_ZONE_TRACTOR_SLOWDOWN]: 'event_openMicTractorSlowdown',
  [SHIPMENT_EVENT.DECIDE_RISK_GPT_SHIPMENT_EVENT]: 'event_decideRiskGpt',
  [SHIPMENT_EVENT.UPDATED_FLIGHT_INFO]: 'event_updatedFlightInfo',
  [SHIPMENT_EVENT.AWB_MANIFEST_ON_FLIGHT]: 'event_manifestOnFlight',
  [SHIPMENT_EVENT.CARRIER_RISKSCORE_SHIPMENT_EVENT]: 'event_carrierRiskScore',
  [SHIPMENT_EVENT.AWB_SPLIT_SHIPMENT]: 'event_splitShipment',
  [SHIPMENT_EVENT.CONVOY_SEPARATION]: 'event_convoyDeviation',
  [SHIPMENT_EVENT.SHIPMENT_STAGING]: 'event_shipmentStaging',
  [SHIPMENT_EVENT.REMOVE_FROM_CONVOY]: 'event_removeFromConvoy',
  [SYSTEM_SHIPMENT_EVENT.USER_ACCEPTED_DELIVERY]: 'event_acceptDelivery',
  [SYSTEM_SHIPMENT_EVENT.USER_REJECTED_DELIVERY]: 'event_rejectDelivery',
  [SYSTEM_SHIPMENT_EVENT.QR_WEBPAGE_ACCESS]: 'event_qrWebpageAccess',
  [SYSTEM_SHIPMENT_EVENT.SEGMENT_CREATED]: 'segment_status_created',
  [SYSTEM_SHIPMENT_EVENT.SHIPMENT_CLOSED]: 'event_shipment_status_closed',
  [SYSTEM_SHIPMENT_EVENT.MARKED_AS_NOT_DELIVERED]: 'event_shipment_status_in_transit',
  [SYSTEM_SHIPMENT_EVENT.SHIPMENT_CREATED]: 'shipment_status_created',
  [SYSTEM_SHIPMENT_EVENT.DELIVERY_ACTION_EXPECTED_SHIPMENT_EVENT]: 'event_deliveryActionExpected',
  [SYSTEM_SHIPMENT_EVENT.WORKFLOW_GROUP_CHANGE_SHIPMENT_EVENT]: 'event_workflow_group_change_shipment_event',
  [SHIPMENT_EVENT.DOUBLE_BROKERED_SHIPMENT_EVENT]: 'event_doubleBrokeredShipmentEvent',
  [SHIPMENT_EVENT.DRIVER_RISKSCORE_SHIPMENT_EVENT]: 'event_driverRiskScore',
  [SHIPMENT_EVENT.FIRST_TIME_DRIVER_SHIPMENT_EVENT]: 'event_firstTimeDriver',
  [SHIPMENT_EVENT.DRIVER_CHECKLIST_SHIPMENT_EVENT]: 'event_driverChecklist',
  [SHIPMENT_EVENT.FIRST_TIME_CARRIER_SHIPMENT_EVENT]: 'event_firstTimeCarrier',
  [SHIPMENT_EVENT.RED_FLAG_PHOTO_ALERT]: 'event_redFlagPhotoAlert',
  [SHIPMENT_EVENT.PICKUP_APPROVAL_REQUESTED_SHIPMENT_EVENT]: 'event_pickupApprovalRequested',
  [SHIPMENT_EVENT.OUT_OF_HOURS_SEAPORT_DEPARTURE]: 'event_outOfHoursSeaportDeparture',
  [SHIPMENT_EVENT.DRIVER_LICENSE_VERIFICATION_FAILED_SHIPMENT_EVENT]: 'event_driverLicenseVerificationFailed',
  [SHIPMENT_EVENT.TELEMATICS_JAMMING]: 'event_telematicsJamming',
  [SHIPMENT_EVENT.ITEM_QUALITY_TEMPERATURE]: 'event_itemQualityTemperature'
}, {
  get: (target, prop: SHIPMENT_EVENT | SYSTEM_SHIPMENT_EVENT) => {
    return prop in target ? target[prop] : prop;
  }
});

export default SHIPMENT_EVENT;
